import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Package, Shield, TrendingUp, CheckCircle } from 'lucide-react';
import { Check } from 'lucide-react';

export default function AmazonBrandRegistry({ onOpenPopup }) {
  const benefits = [
    { icon: <Shield className="h-6 w-6" />, title: 'Brand Protection', description: 'Protect your products from counterfeiters on Amazon' },
    { icon: <TrendingUp className="h-6 w-6" />, title: 'Enhanced Content', description: 'Access to A+ Content and enhanced brand pages' },
    { icon: <Package className="h-6 w-6" />, title: 'Listing Control', description: 'Greater control over product listings and content' },
    { icon: <CheckCircle className="h-6 w-6" />, title: 'Buy Box Priority', description: 'Improved chances of winning the Buy Box' },
  ];

  const details = [
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Trademark Registration', description: 'We first secure your federal trademark registration, a requirement for Amazon Brand Registry.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Brand Registry Application', description: 'Complete preparation and submission of your Amazon Brand Registry application.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Brand Protection Setup', description: 'Configuration of brand protection tools and reporting mechanisms.' },
    { icon: <Check className="h-5 w-5 text-[#E1A334]" />, title: 'Ongoing Support', description: 'Assistance with brand protection issues and registry maintenance.' },
  ];

  const faqs = [
    { question: 'What are the requirements for Amazon Brand Registry?', answer: 'You need an active registered trademark in the country where you want to enroll. We help you obtain this trademark first.' },
    { question: 'What benefits does Brand Registry provide?', answer: 'Access to tools including enhanced brand content, brand analytics, sponsored brands ads, and proactive brand protection.' },
    { question: 'How long does enrollment take?', answer: 'Once you have a registered trademark, Brand Registry approval typically takes 1-2 weeks.' },
  ];

  return (
    <ServiceTemplate
      title="Amazon Brand Registry"
      subtitle="E-Commerce Brand Protection"
      description="Protect and grow your brand on Amazon with Brand Registry enrollment. Get access to powerful tools and protection features designed specifically for brand owners."
      heroImage="/assets/img/amazon-registery.webp"
      infoImage="https://images.unsplash.com/photo-1755606396356-bdd7cd95df75"
      benefits={benefits}
      details={details}
      faqs={faqs}
      onOpenPopup={onOpenPopup}
      testId="amazon-brand-registry-page"
      metaTitle="Amazon Brand Registry Services - Protect Your Brand on Amazon | Trademark Law Consulting"
      metaDescription="Enroll in Amazon Brand Registry with our expert help. Protect against counterfeits, access A+ Content, enhanced brand pages, and powerful analytics. Trademark registration included."
    />
  );
}
